import React from "react";

const PageViews = React.lazy(() => import("./index"));
const PageViewDetail = React.lazy(() => import("./detail"));

export default [
  { path: "/page_views/users/:user_id", component: PageViewDetail, name: "User Page Views" },
  { path: "/page_views/page", component: PageViewDetail, name: "Page Detail" },
  { path: "/page_views", exact: true, component: PageViews, name: "Page Views" },
];
